import Dialog, { DialogProps } from '@mui/material/Dialog'
import { styled, SxProps, Theme } from '@mui/material/styles'

interface AppDialogWrapperProps extends DialogProps {
    topAlign?: boolean
    paperSx?: SxProps<Theme>
}

const AppDialogWrapper = styled(Dialog, {
    shouldForwardProp: (prop) => prop !== 'topAlign' && prop !== 'paperSx',
})<AppDialogWrapperProps>(({ theme, topAlign = false, paperSx }) => ({
    '& .MuiDialog-container::after': {
        verticalAlign: topAlign ? 'top' : 'middle',
    },

    '& .MuiDialog-paper': {
        borderRadius:
            typeof theme.shape.borderRadius === 'number'
                ? theme.shape.borderRadius * 2
                : theme.shape.borderRadius,
        boxShadow: theme.shadows[24],
        ...paperSx,
    },
}))

export default AppDialogWrapper
